// src/i18n/es/auth.js
const auth = {
    login: {
        title: 'Iniciar Sesión',
        subtitle: 'Sistema de Gestión de Taquillas',
        username: 'Correo electrónico',
        password: 'Contraseña',
        sign_in: 'Iniciar sesión',
        remember_me: 'Recordarme',
        forgot_password: '¿Olvidó su contraseña?',
        error: 'Usuario o contraseña incorrectos',
        loading: 'Iniciando sesión...',
    },
    logout: {
        title: 'Cerrar Sesión',
        message: '¿Está seguro que desea cerrar sesión?',
        confirm: 'Cerrar sesión',
        cancel: 'Cancelar',
    },
    errors: {
        invalid_credentials: 'Credenciales inválidas',
        session_expired: 'Su sesión ha expirado',
        unauthorized: 'No tiene permisos para acceder a este recurso',
        forbidden: 'Acceso denegado',
        network_error: 'Error de conexión',
    },
    password: {
        change_title: 'Cambiar Contraseña',
        reset_title: 'Restablecer Contraseña',
        current: 'Contraseña actual',
        new: 'Nueva contraseña',
        confirm: 'Confirmar nueva contraseña',
        requirements: {
            title: 'La contraseña debe tener:',
            minLength: 'Al menos 8 caracteres',
            uppercase: 'Una letra mayúscula',
            lowercase: 'Una letra minúscula',
            number: 'Un número',
            special: 'Un carácter especial (!@#$%^&*)',
        },
        errors: {
            mismatch: 'Las contraseñas no coinciden',
            weak: 'La contraseña es muy débil',
            same: 'La nueva contraseña debe ser diferente a la actual',
        },
        success: 'Contraseña actualizada correctamente',
    },
    profile: {
        title: 'Mi Perfil',
        edit: 'Editar perfil',
        change_password: 'Cambiar contraseña',
        logout: 'Cerrar sesión',
        role: 'Rol',
        hotel: 'Hotel',
        group: 'Grupo',
        last_login: 'Último acceso',
    },
    roles: {
        SuperAdmin: 'Super Administrador',
        GroupAdmin: 'Administrador de Grupo',
        HotelAdmin: 'Administrador de Hotel',
        Receptionist: 'Recepcionista',
        User: 'Usuario',
    },
    session_expiry: {
        title: 'Sesión a punto de expirar',
        message: 'Tu sesión expirará en {time}. ¿Deseas extenderla?',
        time_remaining: 'Tiempo restante',
        extend: 'Extender sesión',
        info: 'Por seguridad, las sesiones expiran después de un período de inactividad. Puedes extender tu sesión o cerrar sesión ahora.',
    },
};

export default auth;